import { render, staticRenderFns } from "./koselugoBlock.vue?vue&type=template&id=4ff355c5&scoped=true"
import script from "./koselugoBlock.vue?vue&type=script&lang=js"
export * from "./koselugoBlock.vue?vue&type=script&lang=js"
import style0 from "./koselugoBlock.vue?vue&type=style&index=0&id=4ff355c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff355c5",
  null
  
)

export default component.exports